import logger from '@clamjs/logger';
import got from 'got';

const EDITH_HOST = 'https://edith.alibaba-inc.com/api/spm/requestSpmb';

export interface ApplySpmOptions {
  userId: string;
  nick: string;
  pageDesc: string;
  pageName: string;
  wlPageUrl: string;
}

export interface ApplySpmRes {
  success: boolean;
  data: {
    spma: string;
    pageName: string;
    pageUrl: null;
    wlPageUrl: string;
    insertUserId: string;
    pageDesc: string;
    isEdit: string;
    isRegexpUrl: string;
    insertUserName: string;
    appFrom: string;
    spmb: string;
    id: number;
    spmId: string;
  };
}

export const applySpmInfo = async (options: ApplySpmOptions) => {
  const { data, success } = await got
    .post(EDITH_HOST, {
      json: {
        spma: '181',
        appFrom: 'edith',
        insertUserId: options.userId,
        insertUserName: options.nick,
        pageDesc: options.pageDesc,
        pageName: options.pageName.replace(/\s/gu, ''),
        wlPageUrl: options.wlPageUrl,
      },
      responseType: 'json',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .json<ApplySpmRes>();

  if (!success) {
    logger.error(
      '自动申请 spm 失败请手动申请并修改 html 的值 -> https://aliyuque.antfin.com/fliggy/engineering/acibg2#r1mBp',
    );
  }
  return data;
};
